import type {PS} from '@wix/document-services-types'

const getMasterPageDataItemPointer = (ps: PS) => ps.pointers.data.getDataItemFromMaster('masterPage')
const getLayoutSettings = (ps: PS) =>
    ps.dal.get(ps.pointers.getInnerPointer(getMasterPageDataItemPointer(ps), 'layoutSettings')) || {}

export default {
    getLayoutSettings
}
